import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

import './style.scoped.scss';

const ComparisonSearch = ({
  handleSearch,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleInput = (e) => {
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      handleSearchClick();
    }
    setSearchValue(e.target.value);
  };

  const handleSearchClick = () => {
    if (searchValue && searchValue.replace(/\s|s|S/g, '').length !== 0) {
      handleSearch(searchValue);
    } else alert('Invalid search value');
  };

  return (
    <div className="comparison-search p-1">
      <input
        className="comparison-search__input"
        placeholder="Comparison Search..."
        onKeyDown={handleInput}
        onChange={handleInput}
      />
      <FaSearch onClick={handleSearchClick} />
    </div>
  );
};

export default ComparisonSearch;
